import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
//Redux
import { getUserbasedonProjects } from 'store/manageclient/action'

const ExpandRow = (props) => {
  const { row, userColumns} = props;
  const {  userLists } = useSelector(state => ({
    userLists: state?.manageclient?.getUsersLists
  }));
  const getSelectedRow = userLists && userLists[row?.id];
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getUserbasedonProjects(row?.id))
  }, [row?.categoryid])


  return <>
    <BootstrapTable
      keyField="userId"
      data={getSelectedRow || []}
      columns={userColumns}
      headerClasses="table-light"
      defaultSortDirection="asc"
      noDataIndication="Sorry, There are no data to display" />
  </>
}

export default ExpandRow;